import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
export var timed = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(promise) {
    var startTime, result, duration;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          startTime = Date.now();
          _context.next = 3;
          return promise;
        case 3:
          result = _context.sent;
          duration = Date.now() - startTime;
          return _context.abrupt("return", {
            result: result,
            durationMs: duration
          });
        case 6:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function timed(_x) {
    return _ref.apply(this, arguments);
  };
}();